import { createContext } from 'react';

import type { InvitedAppShortcutAllowedApsKey } from '../../common/types';

interface InvitedAppShortcutsContextProps {
	impressedProducts: Record<InvitedAppShortcutAllowedApsKey, boolean>;
}

export const InvitedAppShortcutsContext = createContext<InvitedAppShortcutsContextProps>({
	impressedProducts: {
		JIRA_SOFTWARE: false,
		CONFLUENCE: false,
	},
});
